<template>
  <div v-if="showLogin" class="lg-wrap">
    <!-- LEFT: gradient hero -->
    <section class="lg-hero">
      <span class="lg-spark" style="left:14%;top:18%;--o:.6;font-size:22px"><span class="mdi mdi-star-four-points"></span></span>
      <span class="lg-spark" style="left:78%;top:30%;--o:.5;font-size:16px;animation-delay:1s"><span class="mdi mdi-star-four-points"></span></span>
      <span class="lg-spark" style="left:60%;top:72%;--o:.45;font-size:18px;animation-delay:.6s"><span class="mdi mdi-star-four-points"></span></span>
      <!-- seasonal decorations (same layer as the sparkles, behind hero content) -->
      <MothersDayOverlay v-if="uiTheme === 'mothersday'" class="lg-ov" />
      <LoyKrathongOverlay v-if="uiTheme === 'loykrathong'" class="lg-ov" />
      <NewYearOverlay v-if="uiTheme === 'newyear'" class="lg-ov" />
      <SongkranOverlay v-if="uiTheme === 'songkran'" class="lg-ov" />
      <HalloweenOverlay v-if="uiTheme === 'halloween'" class="lg-ov" />
      <ChristmasOverlay v-if="uiTheme === 'christmas'" class="lg-ov" />
      <FathersDayOverlay v-if="uiTheme === 'fathersday'" class="lg-ov" />
      <MuayThaiOverlay v-if="uiTheme === 'muaythai'" class="lg-ov" />
      <div>
        <div class="lg-logo"><img src="../assets/logo/logo-2.png" alt="iStar" /></div>
        <div class="lg-brand">iStar Gymnastics</div>
        <div class="lg-sub">Gymnastics · Class System</div>
      </div>
      <div>
        <!-- i18n hero copy; heroTag holds static <br /> line breaks (safe: fixed i18n text, not user input) -->
        <div class="lg-tag" v-html="$t('auth.heroTag')"></div>
        <div class="lg-blurb">{{ $t('auth.heroBlurb') }}</div>
      </div>
      <div class="lg-foot">© 2026 iStar Gymnastics</div>
    </section>

    <!-- RIGHT: login form -->
    <section class="lg-form">
      <!-- twinkling sparkles (shown only on narrow screens where the hero is hidden) -->
      <span class="lg-form-spark" style="left:12%;top:14%;font-size:20px"><span class="mdi mdi-star-four-points"></span></span>
      <span class="lg-form-spark" style="left:82%;top:22%;font-size:15px;animation-delay:1s"><span class="mdi mdi-star-four-points"></span></span>
      <span class="lg-form-spark" style="left:18%;top:80%;font-size:18px;animation-delay:.5s"><span class="mdi mdi-star-four-points"></span></span>
      <span class="lg-form-spark" style="left:74%;top:86%;font-size:14px;animation-delay:.8s"><span class="mdi mdi-star-four-points"></span></span>
      <!-- seasonal decorations on the mobile canvas (hero is hidden on small screens) -->
      <MothersDayOverlay v-if="uiTheme === 'mothersday'" class="lg-ov lg-ov-m" />
      <LoyKrathongOverlay v-if="uiTheme === 'loykrathong'" class="lg-ov lg-ov-m" />
      <NewYearOverlay v-if="uiTheme === 'newyear'" class="lg-ov lg-ov-m" />
      <SongkranOverlay v-if="uiTheme === 'songkran'" class="lg-ov lg-ov-m" />
      <HalloweenOverlay v-if="uiTheme === 'halloween'" class="lg-ov lg-ov-m" />
      <ChristmasOverlay v-if="uiTheme === 'christmas'" class="lg-ov lg-ov-m" />
      <FathersDayOverlay v-if="uiTheme === 'fathersday'" class="lg-ov lg-ov-m" />
      <MuayThaiOverlay v-if="uiTheme === 'muaythai'" class="lg-ov lg-ov-m" />
      <div class="lg-card">
        <div class="lg-mbrand">
          <div class="lg-logo"><img src="../assets/logo/logo-2.png" alt="iStar" /></div>
          <div class="lg-brand">iStar Gymnastics</div>
          <div class="lg-sub">Gymnastics · Class System</div>
        </div>
        <h2 class="lg-title">{{ $t('auth.loginTitle') }}</h2>
        <p class="lg-welcome">{{ $t('auth.welcome') }} {{ $t('auth.welcomeSub') }}</p>
        <v-card class="pa-5" rounded="xl" elevation="2">
          <v-form ref="login_form" v-model="login_form" @submit.prevent="doLogin">
            <v-text-field class="mb-3" variant="solo-filled" flat prepend-inner-icon="mdi-account-outline"
              v-model="username" :label="$t('auth.username')" :rules="nameRules"
              @input="removeSpaces('username')" :placeholder="$t('auth.username')" name="username"
              autocomplete="username" required></v-text-field>
            <v-text-field class="mb-4" variant="solo-filled" flat prepend-inner-icon="mdi-lock-outline"
              v-model="password" :label="$t('auth.password')"
              :type="showpassword ? 'text' : 'password'" :rules="passwordRules" :placeholder="$t('auth.password')"
              :append-inner-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append-inner="showpassword = !showpassword" name="password" autocomplete="current-password"
              required></v-text-field>
            <button type="submit" class="id-btn id-btn-primary lg-submit">
              <span class="mdi mdi-login"></span> {{ $t('auth.loginBtn') }}
            </button>
            <div class="lg-links">
              <button type="button" class="id-btn id-btn-soft id-btn-sm" @click="registerClick">
                <span class="mdi mdi-account-plus-outline"></span> {{ $t('auth.registerBtn') }}
              </button>
              <button type="button" class="id-btn id-btn-ghost id-btn-sm" @click="forgotpassword">
                <span class="mdi mdi-lock-question"></span> {{ $t('auth.forgotBtn') }}
              </button>
            </div>
          </v-form>
        </v-card>
      </div>
    </section>
  </div>
  <div v-else></div>
</template>

<script>

import axios from 'axios';
import CryptoJS from 'crypto-js';
import { mapGetters } from "vuex";
import { t } from "@/i18n";
import MothersDayOverlay from './theme/MothersDayOverlay.vue';
import LoyKrathongOverlay from './theme/LoyKrathongOverlay.vue';
import NewYearOverlay from './theme/NewYearOverlay.vue';
import SongkranOverlay from './theme/SongkranOverlay.vue';
import HalloweenOverlay from './theme/HalloweenOverlay.vue';
import ChristmasOverlay from './theme/ChristmasOverlay.vue';
import FathersDayOverlay from './theme/FathersDayOverlay.vue';
import MuayThaiOverlay from './theme/MuayThaiOverlay.vue';
export default {
  components: {
    MothersDayOverlay, LoyKrathongOverlay, NewYearOverlay, SongkranOverlay,
    HalloweenOverlay, ChristmasOverlay, FathersDayOverlay, MuayThaiOverlay,
  },
  props: {
    // active seasonal theme (passed from App.vue) — drives the login decorations
    uiTheme: { type: String, default: 'default' },
  },
  data: () => ({
    LogginggIn: false,
    login_form: null,
    username: '',
    password: '',
    showpassword: false,
    nameRules: [
      v => !!v || t('validation.usernameRequired'),
      v => !/\s/.test(v) || t('validation.usernameNoSpaces'),
      // eslint-disable-next-line no-control-regex
      v => /^[\x00-\x7F]+$/.test(v) || t('validation.usernameEnglishOnly'),
    ],
    passwordRules: [
      v => !!v || t('validation.passwordRequired'),
    ],
    showLogin: false,
  }),
  setup() {

  },
  methods: {
    async doLogin() {
      const { valid } = await this.$refs.login_form.validate()
      if (valid) {
        this.$emit('onLoading', true)
        setTimeout(() => {
          const encryptedPassword = this.encryptPassword(this.password);
          axios
            .post(this.baseURL + '/login', {
              username: this.username,
              password: encryptedPassword,
            })
            .then(response => {
              //console.log('login ', response);

              if (response.data.success) {
                //tokenService.setToken(response.data.token);
                // Redirect or perform other actions on successful login
                localStorage.setItem('token', response.data.token);
                localStorage.setItem("userdata", JSON.stringify(response.data.userdata));
                //console.log("USER DATA " + localStorage.getItem("userdata"));
                // Example usage in Login.vue
                this.$store.dispatch('setToken', { token: response.data.token, userdata: response.data.userdata });

                this.$emit('onAffterLogin')
              } else {
                this.$emit('onErrorHandler', response.data.message)
              }

              this.$emit('onLoading', false)
            })
            .catch(error => {
              //console.log('error '+ error);
              //console.error(error);
              this.$emit('onLoading', false)
              this.$emit('onErrorHandler', error.message)
            });
        }, 1500);
      }
    },
    encryptPassword(password) {
      const encryptedPassword = CryptoJS.SHA256(password).toString();

      return encryptedPassword;
    },
    reset() {
      this.LogginggIn = false;
      this.$refs.login_form.reset()
    },
    resetValidation() {
      this.$refs.login_form.resetValidation()
    },
    registerClick() {
      this.$emit('onResigterHandler', 'register')
    },
    forgotpassword() {
      this.$emit('onResigterHandler', 'forgotpassword')
    },
    removeSpaces(field) {
      this[field] = this[field].replace(/\s+/g, '');
    }
  },
  async created() {
        this.$emit('onLoading', true)
        try {
            const token = localStorage.getItem('token');
            //console.log('check token '+ token)
            // ⚠️ ต้องมีครบทั้ง token และ userdata ถึงจะ auto-login ได้
            // มี token อย่างเดียวไม่พอ: AffterLogin() ต้องใช้ userdata ตั้ง usertype/flags/state
            // ถ้าไม่มี มันจะเด้งกลับ state='login' แต่ showLogin ยังเป็น false → ฟอร์มไม่ถูกวาด
            // = จอขาว และวนซ้ำทุกครั้งที่รีเฟรช (เจ้าของเจอจริงบน prod 2026-07-31)
            // สถานะแบบนี้เกิดได้จริงเพราะตอน session หมดอายุ ระบบลบ userdata แต่เคยทิ้ง token ไว้
            const userdata = localStorage.getItem('userdata');
            if (!token || !userdata) {
                // สถานะค้างครึ่ง ๆ — ล้างให้สะอาดแล้วให้ผู้ใช้ล็อกอินใหม่
                // ต้องล้าง Vuex ด้วย ไม่ใช่แค่ localStorage: main.js ยัด token จาก localStorage
                // เข้า store ไปแล้วตั้งแต่ตอน boot ถ้าลบแค่ฝั่ง localStorage จะเหลือ store ที่
                // isLoggedIn=true พร้อม token ที่ไม่มีอยู่จริงแล้ว — สองฝั่งไม่ตรงกันแบบนี้คือ
                // ต้นตอเดียวกับจอขาวที่เจอบน prod
                if (token && !userdata) localStorage.removeItem('token');
                this.$store.dispatch('logout');
                this.showLogin = true;
                this.$emit('onLoading', false)
                return;
            } else {

            await axios
                .post(this.baseURL + '/verifyToken', {}, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                })
                .then(() => {
                    // userdata ตรงนี้เป็น JSON string ดิบจาก localStorage โดยตั้งใจ — ไม่ใช่บั๊ก
                    // store จะ parse ให้เอง (normalizeAuth) ห้ามครอบ JSON.parse ซ้ำตรงนี้
                    this.$store.dispatch('setToken', { token: token, userdata: localStorage.getItem("userdata") });
                    this.$emit('onAffterLogin');
                    this.$emit('onLoading', false)
                })
                .catch(error => {
                    console.error(error);
                    this.showLogin = true;
                    this.$emit('onLoading', false)
                });
              }
        } catch (error) {
            this.$emit('onErrorHandler', error.message)
            this.showLogin = true;
            this.$emit('onLoading', false)
        }
        this.$emit('onLoading', false)

        // ตาข่ายรับชั้นสุดท้าย: ถ้าผ่านมาถึงตรงนี้แล้วยังอยู่ที่หน้า login อยู่ (auto-login ไม่ได้พาไปไหน)
        // ต้องวาดฟอร์มเสมอ ห้ามปล่อยให้จอว่าง — กันบั๊กแบบเดียวกันที่อาจเกิดจากเส้นทางอื่นในอนาคต
        this.$nextTick(() => {
          if (!this.showLogin) {
            console.warn('[istar] auto-login ไม่สำเร็จและไม่ได้เปลี่ยนหน้า — แสดงฟอร์มล็อกอินแทนจอว่าง');
            this.showLogin = true;
          }
        });
    },
    computed: {
      ...mapGetters({
          token: 'getToken',
      })
    },
}
</script>

<style scoped>
/* iStar pink split login. Layout classes (.lg-wrap / .lg-hero / .lg-form /
   .lg-card / .lg-logo / .lg-brand / .lg-sub / .lg-tag / .lg-blurb / .lg-foot /
   .lg-mbrand / .lg-spark) come from the global src/assets/istar-pages.css.
   These scoped rules only cover this page's heading copy + button block. */

/* Make this screen full-bleed above any themed body background. */
.lg-wrap {
  position: fixed;
  inset: 0;
  z-index: 1;
  overflow-y: auto;
}

.lg-title {
  font-family: var(--font-head);
  font-weight: 700;
  font-size: 26px;
  color: var(--c-text-heading);
  margin: 0 0 4px;
}

.lg-welcome {
  color: var(--c-text-muted);
  margin: 0 0 20px;
}

.lg-submit {
  width: 100%;
  height: 46px;
}

.lg-links {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 12px;
}

.lg-links .id-btn {
  width: 100%;
}

/* narrow screen: heading copy sits on the dark pink->purple gradient -> make it white */
@media (max-width: 900px) {
  .lg-title { color: #fff; }
  .lg-welcome { color: rgba(255, 255, 255, 0.85); }
}

/* Seasonal decorations sit at the sparkle layer — above the gradient canvas,
   below the hero/form content (which is z-index:1). The global rule
   `.lg-hero > *:not(.lg-spark)` (and the mobile `.lg-form > *`) would otherwise
   force position:relative + z-index:1 on the overlay, so we pin it here. The
   `.lg-ov-m` copy lives in the form panel and shows only on mobile. */
.lg-ov { position: absolute !important; inset: 0 !important; z-index: 0 !important; }
.lg-ov-m { display: none; }
@media (max-width: 900px) {
  .lg-ov-m { display: block; }
}
</style>